import React, { useState } from 'react';
import { View, Text, FlatList, TouchableOpacity, TextInput } from 'react-native';
import { User } from '../types';
import { styles } from '../styles';

interface PatientsViewProps {
  users: User[];
  onSelectPatient: (user: User) => void;
  title?: string;
  searchPlaceholder?: string;
}

export function PatientsView({ users, onSelectPatient, title = 'Patienten', searchPlaceholder = 'Patient suchen...' }: PatientsViewProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredUsers = users.filter(user => 
    user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.insurance.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const renderItem = ({ item }: { item: User }) => (
    <TouchableOpacity style={styles.patientCard} onPress={() => onSelectPatient(item)}>
      <View style={styles.patientAvatar}>
        <Text style={styles.patientAvatarText}>{item.name.charAt(0)}</Text>
      </View>
      <View style={styles.patientInfo}>
        <Text style={styles.patientName}>{item.name}</Text>
        <Text style={styles.patientDetails}>{item.insurance} • {item.phone}</Text>
      </View>
      <Text style={styles.patientArrow}>›</Text>
    </TouchableOpacity>
  );

  return (
    <View style={styles.contentContainer}>
      <Text style={styles.contentTitle}>{title}</Text>
      <TextInput
        style={styles.searchInput}
        placeholder={searchPlaceholder}
        value={searchQuery}
        onChangeText={setSearchQuery}
      />
      <FlatList
        data={filteredUsers}
        keyExtractor={(item) => item.id.toString()}
        renderItem={renderItem}
        contentContainerStyle={styles.list}
      />
    </View>
  );
}
